/**
 * Minimal fullscreen hook using existing Redux
 */
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { RootState } from '../../../services/serviceTypes';
import { setFullscreenMode } from '../data-store/copilotSlice';

export const useFullscreenRedux = () => {
  const dispatch = useDispatch();
  const copilotState = useSelector((state: RootState) => state.copilot);
  const { fullscreenMode } = copilotState.ui;

  const setIsFullScreen = useCallback(
    (isActive: boolean) => {
      dispatch(
        setFullscreenMode({
          isActive,
          currentStep: fullscreenMode?.currentStep || '',
          buttonConfig: fullscreenMode?.buttonConfig || {
            kind: 'primary',
            label: 'Save',
          },
          filledData: fullscreenMode?.filledData,
          localFields: fullscreenMode?.localFields,
          entitlementIndex: fullscreenMode?.entitlementIndex,
        })
      );
    },
    [dispatch, fullscreenMode]
  );

  const enterFullscreen = useCallback(
    (
      step: string,
      buttonConfig: { kind: string; label: string },
      data?: any,
      entitlementIndex?: number
    ) => {
      dispatch(
        setFullscreenMode({
          isActive: true,
          currentStep: step,
          buttonConfig,
          filledData:
            (data as Record<string, any>) ||
            copilotState.stepFormData[step] ||
            {},
          localFields: copilotState.currentStepData.fields || [],
          entitlementIndex,
        })
      );
    },
    [dispatch, copilotState]
  );

  return {
    isFullscreen: fullscreenMode?.isActive ?? false,
    fullScreenStep: fullscreenMode?.currentStep ?? '',
    filledData: fullscreenMode?.filledData ?? {},
    fullScreenButtonKind: fullscreenMode?.buttonConfig.kind ?? 'primary',
    fullScreenButtonLabel: fullscreenMode?.buttonConfig.label ?? 'Save',
    localFields: fullscreenMode?.localFields ?? [],
    fullScreenEntitlementIndex: fullscreenMode?.entitlementIndex ?? -1,
    setIsFullScreen,
    enterFullscreen,
  };
};

export default useFullscreenRedux;
